import type { TileLayerOptions } from 'leaflet';

export type MapTilerTileLayerConfig = {
  url: string;
  attribution: string;
  maxZoom: number;
};

/** MapTiler "Streets" raster tiles for Leaflet (requires VITE_MAPTILER_API_KEY). */
export function getMapTilerStreetTileLayerConfig(): MapTilerTileLayerConfig {
  const key = import.meta.env.VITE_MAPTILER_API_KEY?.trim();
  if (!key) {
    throw new Error(
      'Missing VITE_MAPTILER_API_KEY. Set it in .env.local for development or in the deployment environment secret for production builds.',
    );
  }

  return {
    url: `https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=${encodeURIComponent(key)}`,
    attribution:
      '&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 20,
  };
}

export function getMapTilerStreetTileLayerOptions(): TileLayerOptions {
  const { attribution, maxZoom } = getMapTilerStreetTileLayerConfig();
  return { attribution, maxZoom };
}
